import { requiredRule, ValidateOptions } from '@.hooks';

import { ApproveProductProposalFormScheme } from './ApproveProductProposalFormScheme';

export const validateOptions = (brandIdRequired: boolean): ValidateOptions<ApproveProductProposalFormScheme> => ({
    udi: {
        type: 'number',
        required: requiredRule,
    },
    brand_id: {
        type: 'number',
        required: brandIdRequired ? requiredRule : undefined,
    },
});
